import React, { useState, useEffect } from 'react';
import { useNavigate, useResolvedPath } from 'react-router-dom';
import styles from './tableTabs.module.css';

// components
import IconButton from '../IconButton/IconButton';
import Filters from '../Filters';
import Button from '../Button/Button';

// icons
import fastsearch from '../../brand/generated/fastSearch.svg';
import advancedSearchCameo from '../../brand/generated/advancedSearch.svg';
import advancedSearchDark from '../../brand/generated/advancedSearchDark.svg';
import plus from '../../brand/generated/buttonIcons/plus.svg';
import calendar from '../../brand/generated/buttonIcons/calendar.svg';
import Permission from '../Permission';
import Hotspot from '../Onboarding/Hotspot';
import { PERMISSION_CAN_CREATE_LEADS } from '../../constants/roles';

const TableTabs = ({
  to,
  setFilter,
  value,
  handleSearchParams,
  handleFastSearchParams,
  filterComponent,
  setValue,
  navigate,
  button,
  buttons,
  inputPlaceholder,
  permission = 'all',
  appliedFilters,
  onRemoveFilter,
  defaultFiltersOpen,
  // false — страница без расширенного поиска (список из одной колонки-ключа)
  advancedSearch = true,
  // false — без кнопки «Добавить» (страница только для чтения)
  addButton = true,
  // Пункт чек-листа обучения: пока он не пройден, на кнопке «Добавить» горит
  // точка-подсказка. Не передали — точки нет.
  hotspotItem,
  hotspotHint,
}) => {
  const navigation = useNavigate();
  const { pathname } = useResolvedPath(to);
  // Пришли по ссылке с фильтрами — панель сразу раскрыта: иначе значения видны
  // только в строке применённых, а поля под ними выглядят пустыми.
  const [showFilters, setShowFilters] = useState(!!defaultFiltersOpen);
  const [filtersKey, setFiltersKey] = useState(0);

  // Сброс — один и тот же и для кнопки в панели, и для строки применённых фильтров:
  // форму надо не только очистить в стейте, но и перемонтировать (ключ), иначе в
  // селектах остаются выбранные значения.
  const resetFilters = () => {
    setFiltersKey((prev) => prev + 1);
    handleSearchParams(true);
  };

  const fastSearch = (e) => {
    if (e.keyCode === 13 || e.type === 'click') {
      setFilter(value);
      // handleFastSearchParams(value);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.firstRow}>
        <div
          style={{
            display: 'flex',
            gap: 15,
          }}
        >
          {addButton && (
            <Permission permission={permission}>
              <span data-tour="table-add">
                <Hotspot item={hotspotItem} hintKey={hotspotHint}>
                  <IconButton text={button} icon={plus} onClick={navigate} />
                </Hotspot>
              </span>
            </Permission>
          )}
          {buttons &&
            buttons?.map((button) => (
              <IconButton text={button.text} icon={button.icon || plus} onClick={button.onClick} />
            ))}
        </div>
        <div className={styles.input} data-tour="table-search">
          <img src={fastsearch} alt="Icon" />
          <input
            value={value}
            type="text"
            placeholder={inputPlaceholder}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={fastSearch}
          />
        </div>
        <Button text={'Найти'} onClick={fastSearch} fill={true} />
        {advancedSearch && (
          <button
            style={pathname === '/records' ? { marginRight: 'auto' } : null}
            data-tour="table-filters"
            className={styles.advancedSearch}
            onClick={() => setShowFilters((prev) => !prev)}
          >
            <img src={showFilters ? advancedSearchDark : advancedSearchCameo} alt="Search" />
            <p style={showFilters ? { color: 'var(--brand-dark)' } : null}>Расширенный поиск</p>
          </button>
        )}
        {pathname === '/records' && (
          <IconButton text={'Открыть календарь'} icon={calendar} onClick={() => navigation('/records/service')} />
        )}
      </div>
      {appliedFilters?.length > 0 && (
        <div className={styles.applied}>
          <span className={styles.appliedTitle}>Фильтры:</span>
          {appliedFilters.map((filter) => (
            <span className={styles.chip} key={filter.name}>
              {filter.label}: <b>{filter.text}</b>
              {onRemoveFilter && (
                <button
                  type="button"
                  className={styles.chipRemove}
                  title={`Убрать фильтр «${filter.label}»`}
                  onClick={() => onRemoveFilter(filter.name)}
                >
                  ×
                </button>
              )}
            </span>
          ))}
          <button type="button" className={styles.appliedReset} onClick={resetFilters}>
            Сбросить
          </button>
        </div>
      )}
      {showFilters && React.cloneElement(filterComponent, { key: filtersKey })}
      {showFilters && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button text={'Сбросить все'} onClick={resetFilters} />
          <Button text={'Найти'} onClick={() => handleSearchParams(false)} fill={true} />
        </div>
      )}
    </div>
  );
};

export default TableTabs;
